import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { Message } from './component/Message'
import OtpTimer from './component/OtpTimer'
import { ThankYou } from './component/ThankYou';
import publicIp from 'public-ip';
import detect from 'detect.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';

import {
  consentCreatePostProcessApi,
  getLeadDetailsByIdAndCoApplicantId,
  logVerificationResponse,
  sendOtpToMobileNumber,
  verifyOtpFromApi,
  getMaskedPhoneAndEmail

} from './service/axiosAPI'
import ModalBootstrap from './component/ModalBootstrap'
import ApplicantTableList from './component/ApplicantTableList';
import { LoaderProgressBar } from './component/LoaderProgressBar';
import { CustomLoader } from './component/CustomLoader'
import MonthlyIncome from './component/MonthlyIncome'
import { ErrorMessage } from './component/ErrorMessage'

function App() {

  // let LESS_THAN_25K = '<= Rs. 25,000 p.m.';
  let BETWEEN_25K_TO_50K = '> Rs. 25,000 and <= Rs. 50,000 p.m.';
  let MORE_THAN_50K = '> Rs. 50,000 p.m.';
  const GET_OTP_BTN = 'GET_OTP_BTN'
  const RESEND_BTN = 'RESEND_BTN'
  const OTP_EXPIRY_TIME = 60 //TIME in seconds

  const [leadDetails, setLeadDetails] = useState()
  const [counter, setCounter] = useState(OTP_EXPIRY_TIME)
  const [mobileNumber, setMobileNumber] = useState()
  const [error, setError] = useState()
  const [apiError, setApiError] = useState()
  const [message, setMessage] = useState()
  const [consentCancelMessage, setConsentCancelMessage] = useState()

  const [isCheckedCheckBox, setIsCheckedCheckBox] = useState(false)
  const [isGetOtpButtonClicked, setIsGetOtpButtonClicked] = useState(true)
  const [isOtpDisable, setIsOtpDisable] = useState(true)
  const [isShowResendButton, setIsShowResendButton] = useState(false)
  const [isConsentAccepted, setIsConsentAccepted] = useState(false)

  const [isVerified, setIsVerified] = useState(false)
  const [isShowTimer, setIsShowTimer] = useState(false)
  const [isLoading, setIsLoading] = useState({
    show: false,
    message: ""
  })

  const [isSpinAcceptButton, setIsSpinAcceptButton] = useState(false)
  const [isSpinCancelButton, setIsSpinCancelButton] = useState(false);
  const [isCameraMandatory, setIsCameraMandatory] = useState(false);

  const [isModalShow, setIsModalShow] = useState(false);
  const [capturedImage, setCapturedImage] = useState("");
  const [politicallyExposed, setPoliticallyExposed] = useState("No");
  const [relativeOfDirector, setRelativeOfDirector] = useState("No");
  const [monthlyIncome, setMonthlyIncome] = useState("");
  const [monthlyIncomeApplicable, setMonthlyIncomeApplicable] = useState(false);
  const [relativeOfDirectorApplicable, setRelativeOfDirectorApplicable] = useState(false);

  const [thankYouMessage, setThankYouMessage] = useState("");

  const [monthlyIncomeArray, setMonthlyIncomeArray] = useState([

    {
      income: BETWEEN_25K_TO_50K,
      isChecked: false
    },
    {
      income: MORE_THAN_50K,
      isChecked: false
    },
  ]);

  const [apiProgress, setApiProgress] = useState(0);
  const [postOtpVerified, setPostOtpVerified] = useState({
    verificationDate: "",
    verificationMessage: ""
  });

  const [consentAccepted, setconsentAccepted] = useState({
    isAccepted: false,
    message: '',
  })
  const [consentApplicantType, setConsentApplicantType] = useState("");

  const [leadID, setLeadID] = useState('');
  const [activityID, setactivityID] = useState('')
  const [eventCODE, seteventCODE] = useState('')
  const [coApplicant, setCoApplicant] = useState('')
  const [maskedMobileNumber, setMaskedMobileNumber] = useState('')
  const [mobileOtp, setMobileOtp] = useState("");


  const handleMonthlyIncome = (income) => {

    const updatedIncome = monthlyIncomeArray.filter((value) => {
      if (value.income === income) {
        if (document.getElementById(value.income).checked) {
          document.getElementById(value.income).setAttribute("checked", true);
          setMonthlyIncome(income);
        } else {
          setMonthlyIncome("");
          document.getElementById(value.income).removeAttribute("checked");
          document.getElementById(value.income).checked = false;
        }
      } else {
        document.getElementById(value.income).removeAttribute("checked");
        document.getElementById(value.income).checked = false;
      }
      return value;
    });
    setMonthlyIncomeArray(updatedIncome);
  }

  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
  }

  const [inputRef, setInputFocus] = useFocus();

  useEffect(() => {
    setInputFocus();
  }, [isOtpDisable])

  useEffect(() => {

    let search = window.location.search
    let params = new URLSearchParams(search)
    let requestedLeadId = params.get('leadid')
    let requestedActivityId = params.get('activityid')
    let requestedEventcode = params.get('eventcode')
    let requestedCoApplicant = params.get('coapplicant') | 0;

    setLeadID(requestedLeadId);
    setactivityID(requestedActivityId);
    seteventCODE(requestedEventcode);
    setCoApplicant(requestedCoApplicant);

    if (!requestedLeadId && !requestedActivityId && !requestedEventcode) {
      setError('Lead Id, Activity Id, Event Code is not provided in the URL.');
      return false;
    }

    setIsLoading({
      show: true,
      message: "Please wait while we are fetching applicants details."
    })

    fetchMaskedEmailAndMobile(requestedActivityId,
      requestedEventcode,
      requestedCoApplicant,)

  }, [])

  useEffect(() => {
    if (isVerified) {
      setIsLoading({
        show: true,
        message: "Please wait while we load your consent form."
      });
      fetchLeadDetailsByIdAndCoApplicantId(
        leadID,
        activityID,
        eventCODE,
        coApplicant,
        mobileOtp
      ).finally(() => {
        setIsLoading({ show: false, message: "" });
      });

    }

  }, [isVerified]);

  useEffect(() => {
    if (leadDetails && leadDetails?.hideOnForm?.phone) {
      setMobileNumber(leadDetails?.hideOnForm?.phone)
    }
    if (leadDetails && leadDetails?.hideOnForm?.politically_exposed) {
      setPoliticallyExposed(leadDetails?.hideOnForm?.politically_exposed);
    }
    if (leadDetails && leadDetails?.hideOnForm?.monthly_household_income && leadDetails?.hideOnForm?.monthly_household_income === "YES") {
      setMonthlyIncomeApplicable(true);
    }
    if (leadDetails && leadDetails?.hideOnForm?.relative_of_director_of_pfpl && leadDetails?.hideOnForm?.relative_of_director_of_pfpl === "YES") {
      setRelativeOfDirectorApplicable(true);
    }

  }, [leadDetails]);

  useEffect(() => {
    if (leadDetails && leadDetails?.hideOnForm?.isIndividual && isVerified) {
      if (leadDetails?.hideOnForm?.isIndividual === "Non-Individual") {
        setIsCameraMandatory(false);
        setConsentApplicantType("Non-Individual")
      } else {
        if (leadDetails?.hideOnForm?.isCameraMandatory === "Y") {
          setIsCameraMandatory(true);
        }
        setConsentApplicantType("Individual")
      }
    }
  }, [isVerified])


  const handleOtp = async (inputOtp) => {
    if (inputOtp.length === 6) {
      setMobileOtp(inputOtp)
      await verifyOtp(activityID, eventCODE, coApplicant, inputOtp);
    }
  }

  function maskMobile(phone) {
    phone = phone ? phone.toString() : "";
    phone = phone ? phone.slice(-10) : "";
    let str = '';
    for (let i = 0; i < phone.length; i++) {
      if (phone.charAt(i) !== "-" && i < 0) {
        str += phone.charAt(i);
      } else if (phone.charAt(i) !== "-" && i > 5) {
        str += phone.charAt(i);
      } else
        str += 'X';
    }
    return str;
  }


  const otpCounter = (time) => {
    setCounter(time)
    if (!isVerified && time === 0) {
      setIsShowResendButton(true)

    }
  }
  const otpSendSuccess = () => {
    setIsShowTimer(true)
    setIsGetOtpButtonClicked(false)

  }
  const otpVerifiedSuccess = () => {
    setIsShowTimer(false)
    setTimeout(() => {
      setIsModalShow(true)
      setIsVerified(true);
    }, 500);
  }
  const otpResendSuccess = () => {
    setIsShowResendButton(false)
    setCounter(OTP_EXPIRY_TIME)
    setIsShowTimer(true)
  }

  const otpClickAction = async (actionName) => {

    if (actionName === GET_OTP_BTN) {


      await sendOtp(activityID, coApplicant, eventCODE)
    } else if (actionName === RESEND_BTN) {

      await reSendOtp(activityID, coApplicant, eventCODE)
    }
  }

  const acceptConsent = async () => {
    if (monthlyIncomeApplicable && !monthlyIncome) {
      alert("Please check MONTHLY HOUSEHOLD INCOME in the form.");
      return false;
    }

    if (!capturedImage && isCameraMandatory) {
      setIsModalShow(true);
      return false;
    }
    if (!isVerified) {
      alert('Please verify the OTP before submitting your consent..');
      return false
    }
    await sendAcceptConsentRequest(leadDetails);
  }


  /*******************Fetched Masked Email and Phone ******************************* */
  const fetchMaskedEmailAndMobile = async (activityId,
    eventCode,
    coapplicant) => {
    await getMaskedPhoneAndEmail(
      activityId,
      eventCode,
      coapplicant
    )
      .then((response) => {
        if (response?.data?.statusCode) {
          setIsLoading({
            show: false,
            message: ""
          });
          if (response?.data?.statusCode === 200) {
            let maskedEmailPhoneResp = (response?.data?.message);
            console.log("Masked email and phone resp >>>", maskedEmailPhoneResp);
            console.log("Masked phone resp >>>", maskedEmailPhoneResp.maskedMobile);

            if (maskedEmailPhoneResp.consentAccepted === "Yes") {
              setconsentAccepted({
                isAccepted: true,
                message: `Hi, You have already submitted your consent.`,
              });
              setIsModalShow(false);
              setIsLoading({
                show: false,
                message: ""
              });
            }
            setMaskedMobileNumber(maskedEmailPhoneResp.maskedMobile);


          } else {
            let err = response?.data?.message;
            setError(err);
          }
        }
      })
      .catch((error) => {
        setIsLoading({
          show: false,
          message: ""
        });
        if (error.toString().includes('504')) {
          setError(error.toString())
        } else {
          setError(' Internal Server Error , Please contact to support team.')
        }
      })
  }

  const fetchLeadDetailsByIdAndCoApplicantId = async (
    leadId,
    activityId,
    eventCode,
    coapplicant,
    mobileOtp
  ) => {
    await getLeadDetailsByIdAndCoApplicantId(
      leadId,
      activityId,
      eventCode,
      coapplicant,
      mobileOtp
    )
      .then((response) => {
        if (response?.data?.message?.errorMessage) {
          setIsLoading({
            show: false,
            message: ""
          });
          setError(`Something went wrong at server side :> ${response.data.message.errorMessage}`);
          return false;
        }

        if (response?.data?.message) {
          setIsLoading({
            show: false,
            message: ""
          });
          if (response?.data?.message?.Status === "Success") {
            let responseOfApplicants = JSON.parse(response?.data?.message?.Data);

            const hideOnForm = responseOfApplicants.hideOnForm;
            console.log("hideOnForm >>>", hideOnForm)
            let name = "";
            if (hideOnForm.hasOwnProperty("customerFullName")) {
              name = hideOnForm['customerFullName'];
              name = name.split(" ")[0];
            }

            // let responseOfApplicants = response?.data?.message?.Data;
            console.log("responseOfApplicants >>>", responseOfApplicants)
            setMobileNumber(responseOfApplicants?.hideOnForm?.phone);
            setPoliticallyExposed(responseOfApplicants?.hideOnForm?.politically_exposed);
            setLeadDetails(responseOfApplicants)
            setIsLoading({
              show: false,
              message: ""
            });

          } else {
            let err = response?.data?.message?.Data;
            setError(err);
          }
        }
      })
      .catch((error) => {
        console.warn('error in calling leaddetails api ', error)
        setIsLoading({
          show: false,
          message: ""
        });
        if (error.toString().includes('504')) {
          setError(error.toString())
        } else {
          setError(' Internal Server Error , Please contact to support team.')
        }
      })
  }
  let tick_interval = 0.8;
  let tick_increment = 2;
  let value = 0;
  let tick_function = function () {
    value += tick_increment;
    if (value < 95) {
      window.setTimeout(tick_function, tick_interval * 1000);
    } else {

    }
    setApiProgress(value);
  };

  const sendAcceptConsentRequest = async (body) => {
    window.setTimeout(tick_function, tick_interval * 1000);

    setIsSpinAcceptButton(true)
    setApiError();
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });

    const generatedPDfDetails = await generatePdfAndUpdateCSF(leadDetails);

    await consentCreatePostProcessApi(body, generatedPDfDetails, mobileOtp)
      .then((response) => {
        const acceptConsent = response[0];
        const postConsent = response[1]
        if (acceptConsent?.data?.message?.errorType && acceptConsent?.data?.message?.errorType.includes('TypeError')) {
          setIsSpinAcceptButton(false)
          setApiError(
            ` Error occured while processing  agree consent request : ${acceptConsent?.data?.message?.errorMessage}.`
          )
        }
        if (acceptConsent?.data?.message?.errorMessage) {
          setIsLoading({
            show: false,
            message: ""
          });
          setError(`Something went wrong at server side :> ${acceptConsent.data.message.errorMessage}`);
          return false;
        }

        if (acceptConsent?.data?.message) {
          setIsLoading({
            show: false,
            message: ""
          });
          setIsSpinAcceptButton(false)
          if (acceptConsent?.data?.message?.Status === "Success") {
            let name = generatedPDfDetails?.customerFullName.split(" ")[0];
            setThankYouMessage(`Thank You ${name}, Your consent is submitted successfully.`);
            setIsSpinAcceptButton(false)
            setIsConsentAccepted(true);
          } else {
            setApiError(postConsent?.data?.message?.Data);
            return false;
          }
        }
      })
      .catch((error) => {
        console.warn('error sendAcceptConsentRequest ', error)
        setApiError(` Error occured while processing agree consent request :${error}`)
        setIsSpinAcceptButton(false)
      })
  }

  const generatePdfAndUpdateCSF = async (body) => {
    let ua = detect.parse(navigator.userAgent);
    const deviceName = `${ua.os.family} | ${ua.browser.family}`;
    const ip = await publicIp.v4();
    const tableHtml = document.getElementById('my-node').innerHTML;

    const info = {
      consentIp: ip,
      consentDate: (postOtpVerified.verificationDate) ? postOtpVerified.verificationDate : moment(new Date()).format('DD-MMM-YYYY h:mm A'),
      consentUser: body?.hideOnForm?.customerFullName ? body?.hideOnForm?.customerFullName : "",
      consentDevice: deviceName,
      applicationReferenceId: body?.hideOnForm?.applicationReferenceId ? body?.hideOnForm?.applicationReferenceId : "",

      Phone: mobileNumber ? maskMobile(mobileNumber) : "",
      mobileNumber: mobileNumber ? mobileNumber : "",
      tableHtml: tableHtml,
      customerImage: capturedImage ? capturedImage : "",
      customerFullName: body?.hideOnForm?.customerFullName ? body?.hideOnForm?.customerFullName : "",
      politicallyExposed: politicallyExposed ? politicallyExposed : "",
      consentApplicantType: consentApplicantType ? consentApplicantType : "",
      relative_of_director_of_pfpl: (relativeOfDirectorApplicable && relativeOfDirector) ? relativeOfDirector : "",
      monthly_household_income: (monthlyIncomeApplicable && monthlyIncome) ? monthlyIncome : "",
      productName: body?.hideOnForm?.product ? body?.hideOnForm?.product : "",
    }
    return info;
  }

  const sendOtp = async (activityID, coApplicant, eventCODE) => {
    setIsLoading({
      show: true,
      message: "Please wait while we are sending OTP to your registered mobile number."
    })
    setMessage()
    await sendOtpToMobileNumber(activityID, coApplicant, eventCODE)
      .then((response) => {
        if (
          response?.data?.statusCode === 200 &&
          response?.data?.message?.includes('error')
        ) {
          setMessage('You are re-trying too early. Please wait for some time.')
        } else if (
          response?.data?.statusCode === 200 &&
          response?.data?.message?.includes('success')
        ) {
          setMessage(`OTP has been sent to mobile number ${maskedMobileNumber}`)
          otpSendSuccess();
          setIsOtpDisable(false);
          setInputFocus();
        } else {
          setMessage(`Failed to sent OTP to mobile number ${maskedMobileNumber}`)
        }
        setIsLoading({
          show: false,
          message: ""
        })
      })
      .catch((error) => {
        setIsLoading({
          show: false,
          message: ""
        })
        console.warn('error >> ', error);
        setMessage(`Failed to sent OTP  ${error}`)
      })
  }
  const reSendOtp = async (activityID, coApplicant, eventCODE) => {
    setIsLoading({
      show: true,
      message: "Please wait while we are Re-sending OTP to your registered mobile number."
    })
    setMessage()
    await sendOtpToMobileNumber(activityID, coApplicant, eventCODE)
      .then((response) => {
        if (
          response?.data?.statusCode === 200 &&
          response?.data?.message?.includes('error')
        ) {
          setMessage('You are re-trying too early. Please wait for some time.')
        } else if (
          response?.data?.statusCode === 200 &&
          response?.data?.message?.includes('success')
        ) {
          setMessage(`OTP has been Re-sent to mobile number ${maskedMobileNumber}`)
          otpResendSuccess();
          setIsOtpDisable(false);
        } else {
          setMessage(`Failed to sent OTP to mobile number ${maskedMobileNumber}`)
        }
        setIsLoading({
          show: false,
          message: ""
        })
      })
      .catch((error) => {
        setIsLoading({
          show: false,
          message: ""
        })
        console.warn('error ', error)
        setMessage(`Failed to Re-sent OTP ${error}`)
      })
  }

  const verifyOtp = async (activityID, eventCODE, coApplicant, otp) => {
    setIsLoading({
      show: true,
      message: "Please wait while we are verifying OTP."
    })
    setMessage('Verifying OTP, please wait.');
    setIsOtpDisable(true);
    let ua = await detect.parse(navigator.userAgent);
    const deviceName = `${ua.os.family} | ${ua.browser.family}`;
    const ip = await publicIp.v4();
    await verifyOtpFromApi(activityID, eventCODE, coApplicant, otp)
      .then((response) => {
        if (
          response?.data?.statusCode === 200 &&
          typeof response?.data?.message === 'string' &&
          response?.data?.message?.includes('error')
        ) {
          logOTPresponse("false")
          setMessage(`OTP could not verified. This OTP is incorrect.`);
          setIsOtpDisable(false);
        } else if (response?.data?.statusCode === 200) {
          let verifyResponse = response?.data?.message;

          if (verifyResponse && verifyResponse?.isOtpVerified) {
            setPostOtpVerified({
              verificationDate: moment(new Date()).format('DD-MMM-YYYY hh:mm A'),
              verificationMessage: `*Through OTP veriﬁcation sent on Mobile No ${maskedMobileNumber} using ${deviceName} from IP ${ip}*`
            })
            logOTPresponse("true")
            setMessage(`OTP verified successfully.`)
            otpVerifiedSuccess();
            setIsVerified(true)
          } else {
            logOTPresponse("false")
            setMessage(`OTP could not verified. This OTP is incorrect.`)
            setIsOtpDisable(false);
          }

        } else {
          setMessage(`OTP Verification failed.`)
          setIsOtpDisable(false);
        }
        setIsLoading({
          show: false,
          message: ""
        })
      })
      .catch((error) => {
        setIsLoading({
          show: false,
          message: ""
        })
        setMessage(`OTP Verification failed. ${error}`);
        setIsOtpDisable(false);
      })
  }


  const logOTPresponse = async (status) => {
    await logVerificationResponse(activityID, coApplicant, eventCODE, leadID, status, mobileOtp);
  }
  const uploadCapturedImage = (file) => {
    setCapturedImage(file);
    setIsModalShow(false);
  }
  const handleClose = () => {
    setIsModalShow(false);
  }


  return (
    <>
      {!isLoading.show && consentAccepted.isAccepted && (
        <ThankYou message={consentAccepted.message} />
      )}
      {/* //thank you page works after submitting consent */}

      {isLoading.show && (
        <div className="App p-5">
          <CustomLoader message={isLoading.message} />
        </div>
      )}
      {/* //loader when any operation is in progress */}
      {
        !leadDetails && error && (
          <ErrorMessage error={error} />
        )}
      {/* //Error message when any error occured*/}

      {!isLoading.show && isConsentAccepted && (
        <>
          <ThankYou message={thankYouMessage} />
        </>
      )}
      {/* Thank you message when consent is already submitted*/}

      {!isLoading.show && consentCancelMessage && (
        <>
          <ThankYou message={consentCancelMessage} />
        </>
      )}
      {/* //After successfully canceleed */}

      {!isLoading.show && isVerified && leadDetails && !isConsentAccepted && !consentAccepted.isAccepted && !consentCancelMessage && (
        <div className="container pt-2 pb-2">
          <div className="custom-template" >
            {leadDetails && isModalShow && isCameraMandatory && (
              <ModalBootstrap uploadCapturedImage={uploadCapturedImage} handleClose={handleClose} />
            )}

            <Row>
              <Col sm={8} md={8} lg={10} xl={10} >
                <img
                  width={270}
                  height={270}
                  alt='poonalogo.jpg'
                  src="./poonalogo.jpg"
                  className="img-fluid"
                ></img>
                <Col  >
                  <div className='Address-bar'>
                    <p className="h5"><strong>POONAWALLA FINCORP LIMITED</strong></p>
                    <p><strong>CIN : </strong>L51504PN1978PLC209007</p>
                    <p><strong>Registered office : </strong> 201 and 202, 2nd floor, AP81, Koregaon Park Annex, Mundhwa, Pune-411036</p>
                    <p><strong>Toll Free No : </strong>1800 266 3201 | <strong>E:</strong> <a href='mailto:customercare@poonawallafincorp.com'>customercare@poonawallafincorp.com</a> </p>
                    <p><strong>E : </strong> <a href='mailto:info@poonawallafincorp.com'>info@poonawallafincorp.com</a> | <strong>W : </strong> <a target="_blank" href='https://www.poonawallafincorp.com'>www.poonawallafincorp.com</a></p>
                  </div>
                </Col>
              </Col>
              <Col sm={4} md={4} lg={2} xl={2} className="justify-content-end" >
                {capturedImage && !isConsentAccepted && (
                  <img
                    alt='customer'
                    src={capturedImage}
                    className="img-thumbnail"
                  ></img>

                )}
              </Col>
            </Row>
            <div className="row text-center mt-4">
              <p className='h4 text-center'>
                <strong>Loan Application Form</strong>
              </p>
            </div>
            <div className="row mx-auto " style={{ overflow: 'auto' }} id='my-node'>
              <table className="table table-sm table-bordered  table-responsive-sm " >
                <tbody>

                  {leadDetails && leadDetails.displayOnForm && (
                    Object.entries(leadDetails.displayOnForm).map(([key, value]) => {
                      return (
                        <ApplicantTableList key={key} displayName={key} displayValue={value} />
                      )
                    })
                  )}
                  {monthlyIncomeApplicable && (
                    <tr>
                      <td className='thead'>MONTHLY HOUSEHOLD INCOME (in Rs.)<br></br>
                        (Monthly income of my family unit, i.e., husband, wife, and unmarried children)
                      </td>
                      <td>
                        {monthlyIncomeArray && (
                          monthlyIncomeArray.map((value) => {
                            return (
                              <MonthlyIncome key={value.income} handleMonthlyIncome={handleMonthlyIncome} value={value} />
                            )
                          })
                        )}
                      </td>
                    </tr>
                  )}

                  {relativeOfDirectorApplicable && (
                    <tr>
                      <td className='thead'>Are you relative of Directors/Senior Officer of Poonawalla Fincorp Ltd?</td>
                      <td>
                        <div className='political-radio' >
                          <div className="form-check">
                            <input onChange={() => setRelativeOfDirector("Yes")} defaultChecked={relativeOfDirector === "Yes"} value={relativeOfDirector} className="form-check-input" type="radio" name="relativeOfDirector" id="relative-radio-yes" />
                            <label className="form-check-label" htmlFor="relative-radio-yes">
                              Yes
                            </label>
                          </div>
                          <div className="form-check ms-2">
                            <input onChange={() => setRelativeOfDirector("No")} defaultChecked={relativeOfDirector === "No"} value={relativeOfDirector} className="form-check-input" type="radio" name="relativeOfDirector" id="relative-radio-no" />
                            <label className="form-check-label" htmlFor="relative-radio-no">
                              No
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}


                  {leadDetails && leadDetails?.hideOnForm && leadDetails?.hideOnForm?.politically_exposed && (
                    <tr>
                      <td className='thead'>Whether Politically Exposed Person?</td>
                      <td>
                        <div className='political-radio' >
                          <div className="form-check">
                            <input disabled={consentAccepted.isAccepted} onChange={() => setPoliticallyExposed("Yes")} defaultChecked={politicallyExposed === 'Yes'} value={politicallyExposed} className="form-check-input" type="radio" name="politicallyExposed" id="radio-yes" />
                            <label className="form-check-label" htmlFor="radio-yes">
                              Yes
                            </label>
                          </div>
                          <div className="form-check ms-2">
                            <input disabled={consentAccepted.isAccepted} onChange={() => setPoliticallyExposed("No")} defaultChecked={politicallyExposed === 'No'} value={politicallyExposed} className="form-check-input" type="radio" name="politicallyExposed" id="radio-no" />
                            <label className="form-check-label" htmlFor="radio-no">
                              No
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
            <div className="row mt-4">
              <div className='col'>
                <p>The list of <b>documents</b> & list of <b>charges</b> applicable are available on website of the Company, the link of the same is: <a href="https://www.poonawallafincorp.com" target="_blank" rel="noreferrer"><b>www.poonawallafincorp.com</b></a></p>
              </div>
            </div>
            <div className="row mt-4">
              <div className='col'>
                <p><b><u>Please note, the Company has the following Approach/Factors for Gradation of Risk:</u></b></p>
              </div>
              <div className="row mt-4  ml-2">
                <div className='col'>
                  <p>All “Borrower/s” on the loan facility are hereby informed that the company has the following approach and considers following factors for assessing gradation of risks for each Borrower: </p>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className='col ml-2'>
                <ul>
                  <li>Profile, financial stability, and market reputation. </li>
                  <li>Credit history and duration of relationship with the Borrower. </li>
                  <li>Group strength, overall customer yield, future potential, repayment capacity based on cash flows and other financial commitments. </li>
                  <li>Interest, default risk in related customer segment. </li>
                  <li>The security for the loan as represented by the underlying assets.</li>
                  <li>Loan to value ratio.</li>
                  <li>Mode of payment.</li>
                  <li>Tenure of the loan.</li>
                  <li>Geography (location) of the Borrower.</li>
                  <li>End use.</li>
                  <li>RBI guidelines, other laws or any other factors on a case-by-case basis, as applicable.</li>
                </ul>
              </div>
            </div>
            <div className="row mt-4">
              <div className="row mt-4 ml-2">
                <div className='col'>
                  <p>
                    I/We understand that the rate of interest is in accordance with &nbsp;
                    <a
                      href="https://poonawallafincorp.com/documents/d/poonawalla-fincorp/interest-rate-policy"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b>Interest Rate Policy</b>
                    </a> of the Company.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="row"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Please verify OTP before accepting agreements."
            >
              <div className="form-check m-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  onChange={() => {
                    isCheckedCheckBox === true
                      ? setIsCheckedCheckBox(false)
                      : setIsCheckedCheckBox(true)
                  }}
                  disabled={!isVerified}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Please verify OTP before accepting agreements."

                />
                <p className='ml-2'>
                  By proceeding, I/We hereby confirm that I/We have read, understood and hereby agree to abide by all &nbsp;<a href="https://poonawallafincorp.com/terms-of-use.php" target="_blank" rel="noreferrer"><b>terms and conditions</b></a> including the &nbsp;<a href="https://poonawallafincorp.com/legal-disclaimer.php" target="_blank" rel="noreferrer"><b>disclaimer</b></a> pertaining to the aforementioned loan facility which is available in the website of the Poonawalla Fincorp Limited (“the Company”) and I/We hereby voluntarily accord my  &nbsp;<a href="https://poonawallafincorp.com/aadhaar-number-consent.php" target="_blank" rel="noreferrer"><b>Aadhaar Consent</b></a> and also hereby authorize the Company and its representatives to contact me/us through phone call, SMS, WhatsApp and/or any other mode (this shall override any registration by myself/us under DNC/NDNC) and also to make any inquires regarding my/our aforementioned application as they may consider necessary at their sole discretion. I/We also authorize the Company to make any enquiry with NSDL/Credit bureau or any regulatory authority or any such third party regarding my/our PAN, Credit history or for any other verifications.<br></br><br></br>

                  I/We hereby provide my consent and authorize the Company and/or its affiliated partners to download my ‘Know Your Customer’ records/information from the Central KYC Registry. I am/We are aware that my/our KYC records/information would be downloaded from the Central KYC Registry, solely for performing customer due diligence on me/us in order to process my loan application. I/We further declare that the data/ information on the Central KYC Registry is updated and has not been subjected to any change, as on the date of making the loan application.<br></br><br></br>

                  I/We hereby also confirm that all the documents submitted and also the information furnished to the Company to process my/our loan application are true and no material information are suppressed or withheld.<br></br><br></br>

                  I/We hereby also confirm that my/our consent and declarations as provided herein will remain valid and abiding on me/us even if any of the details mentioned herein above (Including my/our e-mail or mobile number) changes, in which case, I/we shall forthwith inform the Company about such change. I/We have no objection to sharing of my name, mobile number, e-mail ID, PAN and /or such other information, with Poonawalla Fincorp Limited  and/ or its group companies and/ or its agents, representatives for providing me/us information on various products, offers and services provided by Poonawalla Fincorp Limited and/or its group companies through any mode (including telephone calls, SMS/e-mails, letters etc.). I understand that status of this loan application will be known to me /us within seven working days from the date of submission of loan application duly signed by applicant/co-applicant(s) and guarantor(s), as the case may be on my e-mail ID and/or mobile number specified in this loan application.

                </p>

                {eventCODE && (eventCODE === "224" || eventCODE === 224) && (
                  <>
                    <p className='ml-2'>
                      I consent to the collection, storage, and processing of my medical and health-related information by PFL, in accordance with its Privacy Policy and applicable laws, for the purpose of evaluation and servicing of my loan application.
                    </p>
                  </>
                )}

                {eventCODE && (eventCODE === "261" || eventCODE === 261) && (
                  <>
                    <p className='ml-2'>
                      I/We hereby understand and agree that an Initial Processing Fee, as communicated by Poonawalla Fincorp Limited, is payable upfront for processing of this loan application. I/We acknowledge that the said Initial Processing Fee is non-refundable under all circumstances irrespective of whether the Loan is rejected, withdrawn, or cancelled, except where a refund is required under Applicable Law.
                    </p>
                  </>
                )}


              </div>
            </div>
            <div className="row">
              <div className='col'>
                {postOtpVerified?.verificationDate && (
                  <>
                    <p><strong>Application Form Sign Date*: </strong>{postOtpVerified?.verificationDate}</p>
                    <p>{postOtpVerified?.verificationMessage}</p>
                  </>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-sm-6 col-md-6 col-lg-auto col-xl-auto text-start">
                <button
                  type="button"
                  className="btn btn-sm btn-mx btn-blue "
                  disabled={!(isCheckedCheckBox && isVerified)}
                  onClick={() => acceptConsent()}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Agree consent"
                >
                  {isSpinAcceptButton ? 'Processing' : 'Agree'}
                  {isSpinAcceptButton && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-auto col-xl-auto text-end text-sm-end text-md-end text-lg-start text-xl-start">
                {' '}
                <button
                  type="button"
                  className="btn btn-sm btn-mx btn-blue "
                  disabled={true}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Disagree consent"
                >
                  {isSpinCancelButton ? 'Processing' : 'Disagree'}
                  {isSpinCancelButton && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>

              </div>
              {apiError && (
                <div className="App p-4">
                  <div className="alert alert-danger" role="alert">
                    {apiError}
                  </div>
                </div>
              )}

            </div>
            {isSpinAcceptButton && (
              <LoaderProgressBar progressDone={apiProgress} />
            )}
          </div>
        </div>
      )}
      {/* //After verification */}

      {!isLoading.show && !isVerified && !consentAccepted.isAccepted && !isConsentAccepted && (
        <div className="container pt-5 pb-2">
          <div className="custom-template" >
            <Row>
              <Col sm={8} md={8} lg={10} xl={10} >
                <img
                  width={270}
                  height={270}
                  alt='poonalogo.jpg'
                  src="./poonalogo.jpg"
                  className="img-fluid"
                ></img>
                <Col  >
                  <div className='Address-bar'>
                    <p className="h5"><strong>POONAWALLA FINCORP LIMITED</strong></p>
                    <p><strong>CIN : </strong>L51504PN1978PLC209007</p>
                    <p><strong>Registered office : </strong> 201 and 202, 2nd floor, AP81, Koregaon Park Annex, Mundhwa,Pune-411036, Maharastra. </p>
                    <p><strong>Toll Free No : </strong>1800 266 3201 | <strong>E:</strong> <a href='mailto:customercare@poonawallafincorp.com'>customercare@poonawallafincorp.com</a> </p>
                    <p><strong>E : </strong> <a href='mailto:info@poonawallafincorp.com'>info@poonawallafincorp.com</a> | <strong>W : </strong> <a target="_blank" href='https://www.poonawallafincorp.com'>www.poonawallafincorp.com</a></p>
                  </div>
                </Col>
              </Col>
            </Row>

            <div className='row mt-5'>
              <div className='col'>
                <p><strong>Dear Customer, To provide your Consent to process your Loan Application, kindly click on "Get OTP" and enter the OTP sent on your mobile number</strong></p>

              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
                <label className="col-form-label thead">Mobile Number</label>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <input
                  type="text"
                  placeholder="Enter Mobile Number"
                  className="form-control"
                  value={maskedMobileNumber}
                  disabled={true}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Mobile number cannot be change from here."
                />
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 pt-3 pt-sm-3 pt-md-2 pt-lg-0 pt-xl-0 ">
                <div className="form">
                  <input
                    type="number"
                    placeholder="Enter OTP"
                    onChange={(e) => handleOtp(e.target.value.trim())}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enter the OTP"
                    disabled={consentAccepted.isAccepted || isOtpDisable}
                    maxLength={6}
                    className="otpfield"
                    ref={inputRef}
                  />
                  {isGetOtpButtonClicked && (
                    <button
                      className="in-button"
                      type="button"
                      onClick={() => otpClickAction(GET_OTP_BTN)}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Get OTP to regisered mobile number."
                    >
                      Get OTP
                    </button>
                  )}

                  {isShowResendButton && (
                    <button
                      className="in-button"
                      type="button"
                      onClick={() => otpClickAction(RESEND_BTN)}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Resend OTP"
                    >
                      Resend OTP
                    </button>
                  )}
                  {isVerified && (
                    <img
                      alt='tick'
                      className="tick"
                      src="./tick.svg"
                      width="25%"
                      height="25%"
                    />
                  )}
                </div>

                {message && <Message message={message} color="green" />}
                {isShowTimer && (
                  <>
                    <OtpTimer otpCounter={otpCounter} counter={counter} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* // before verification */}
    </>
  )
}

export default App
